import { render, staticRenderFns } from "./TablaDuracionesContrato.vue?vue&type=template&id=a576db54"
import script from "./TablaDuracionesContrato.vue?vue&type=script&lang=js"
export * from "./TablaDuracionesContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports